import * as ActionTypes from '../actionTypes';
import apiActionCreator from '../../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../../common/util/errorUtils';
// import {getUrlParameters} from '../../../common/util/urlParameters';
import * as MessageActions from '../../../common/messageBox/actions/actions';

export const getWtsCoursesAreas = (areaSelectedId) => apiActionCreator({
  'endpoint': `/wts/catalog/courses-areas?area=${areaSelectedId}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_WTS_COURSES_AREAS,
    ActionTypes.FETCHED_WTS_COURSES_AREAS,
    [
      ActionTypes.FETCHED_WTS_COURSES_AREAS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const getWtsAreasAdministrador = () => apiActionCreator({
  'endpoint': '/wts/catalog/courses-areas',
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_WTS_COURSES_AREAS_ADMINISTRADOR,
    ActionTypes.FETCHED_WTS_COURSES_AREAS_ADMINISTRADOR,
    [
      ActionTypes.FETCHED_WTS_COURSES_AREAS_FAILED_ADMINISTRADOR,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const changeWtsCourseAreaSelected = (areaSelected) => ({
  'type': ActionTypes.CHANGE_WTS_COURSE_AREA_SELECTED,
  'payload': areaSelected,
});

export const createWtsCoursesArea = (areaSelectedId, data) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/wts/catalog/courses-areas?area=${areaSelectedId}`,
      'authenticated': true,
      'types': [
        ActionTypes.CREATING_WTS_COURSES_AREAS,
        [
          () => {
            dispatch(getWtsCoursesAreas(areaSelectedId));
            return {'type': ActionTypes.CREATED_WTS_COURSES_AREAS};
          },
          MessageActions.addMessageBoxInfo('Área de curso creada satisfactoriamente'),
        ],
        [
          ActionTypes.CREATED_WTS_COURSES_AREAS_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'POST',
      'contentType': 'application/json',
      'data': data,
    })
  );
};

export const updateWtsCoursesArea = (areaSelectedId, data) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/wts/catalog/courses-areas?area=${areaSelectedId}`,
      'authenticated': true,
      'types': [
        ActionTypes.UPDATING_WTS_COURSES_AREAS,
        [
          () => {
            dispatch(getWtsCoursesAreas(areaSelectedId));
            return {'type': ActionTypes.UPDATED_WTS_COURSES_AREAS};
          },
          MessageActions.addMessageBoxInfo('Área de curso modificado satisfactoriamente'),
        ],
        [
          ActionTypes.UPDATED_WTS_COURSES_AREAS_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'PUT',
      'contentType': 'application/json',
      'data': data,
    })
  );
};
